import React from 'react'
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap'
import { Link } from 'react-router-dom'

const ViewNote = ({ isOpen, toggle, note, language }) => {
  if (!note) return null

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size='lg'
      className='modal-dialog-centered'
    >
      <ModalHeader toggle={toggle} className='border-bottom'>
        <div className='d-flex align-items-center'>
          <i className='fa fa-sticky-note text-primary mr-2'></i>
          <h4 className='modal-title mb-0'>{note.name || 'Note'}</h4>
        </div>
      </ModalHeader>
      <ModalBody className='py-4'>
        <div className='note-content'>
          {note.note_text ? (
            <div
              dangerouslySetInnerHTML={{ __html: note.note_text }}
              style={{
                minHeight: '200px',
                padding: '15px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                lineHeight: '1.6',
              }}
            />
          ) : (
            <div
              className='text-muted text-center py-5'
              style={{
                minHeight: '200px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
              }}
            >
              <div>
                <i className='fa fa-file-text fa-3x text-muted mb-3'></i>
                <p>No content available for this note.</p>
              </div>
            </div>
          )}
        </div>

        <div className='d-flex justify-content-end mt-4'>
          <Button color='secondary' onClick={toggle} className='mr-2'>
            <i className='fa fa-times mr-1'></i>
            {language?.general?.close || 'Close'}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ViewNote
